import {
  CHANGE_USER_STATUS,
  CHANGE_USER_STATUS_FAILURE,
  CHANGE_USER_STATUS_SUCCESS,
  GET_USER_LISTING,
  GET_USER_LISTING_FAILURE,
  GET_USER_LISTING_SUCCESS,
  GET_USER_LOCATIONS,
  GET_USER_LOCATIONS_FAILURE,
  GET_USER_LOCATIONS_SUCCESS,
  SEND_USER_EMAIL,
  SEND_USER_EMAIL_FAILURE,
  SEND_USER_EMAIL_SUCCESS,
  SEND_BULK_EMAIL,
  SEND_BULK_EMAIL_FAILURE,
  SEND_BULK_EMAIL_SUCCESS,
  DELETE_USER,
  DELETE_USER_FAILURE,
  DELETE_USER_SUCCESS,
  CREATE_USER,
  CREATE_USER_FAILURE,
  CREATE_USER_SUCCESS,
} from "../constants";

export default class UserAction {
  static getUserListing(payload, cb) {
    return {
      type: GET_USER_LISTING,
      payload,
      cb,
    };
  }
  static getUserListingSuccess(payload) {
    return {
      type: GET_USER_LISTING_SUCCESS,
      payload,
    };
  }
  static getUserListingFailure() {
    return {
      type: GET_USER_LISTING_FAILURE,
    };
  }

  static changeUserStatus(id, cb) {
    return {
      type: CHANGE_USER_STATUS,
      id,
      cb,
    };
  }
  static changeUserStatusSuccess(payload) {
    return {
      type: CHANGE_USER_STATUS_SUCCESS,
      payload,
    };
  }
  static changeUserStatusFailure() {
    return {
      type: CHANGE_USER_STATUS_FAILURE,
    };
  }

  static getUserLocations(keyword, cb) {
    return {
      type: GET_USER_LOCATIONS,
      keyword,
      cb,
    };
  }
  static getUserLocationsSuccess(payload) {
    return {
      type: GET_USER_LOCATIONS_SUCCESS,
      payload,
    };
  }
  static getUserLocationsFailure() {
    return {
      type: GET_USER_LOCATIONS_FAILURE,
    };
  }

  static sendUserEmail(payload, cb) {
    // console.log("send_user_email_a/ction_called", payload);
    return {
      type: SEND_USER_EMAIL,
      payload,
      cb,
    };
  }
  static sendUserEmailSuccess(payload) {
    return {
      type: SEND_USER_EMAIL_SUCCESS,
      payload,
    };
  }
  static sendUserEmailFailure() {
    return {
      type: SEND_USER_EMAIL_FAILURE,
    };
  }

  static sendBulkEmail(payload, cb) {
    return {
      type: SEND_BULK_EMAIL,
      payload,
      cb,
    };
  }
  static sendBulkEmailSuccess(payload) {
    return {
      type: SEND_BULK_EMAIL_SUCCESS,
      payload,
    };
  }
  static sendBulkEmailFailure() {
    return {
      type: SEND_BULK_EMAIL_FAILURE,
    };
  }

  static deleteUser(id, cb) {
    return {
      type: DELETE_USER,
      id,
      cb,
    };
  }
  static deleteUserSuccess(payload) {
    return {
      type: DELETE_USER_SUCCESS,
      payload,
    };
  }
  static deleteUserFailure() {
    return {
      type: DELETE_USER_FAILURE,
    };
  }

  static createUser(payload, cb) {
    return {
      type: CREATE_USER,
      payload,
      cb,
    };
  }
  static createUserSuccess(payload) {
    return {
      type: CREATE_USER_SUCCESS,
      payload,
    };
  }
  static createUserFailure() {
    return {
      type: CREATE_USER_FAILURE,
    };
  }
}
